<div
  *ngIf="organization && urlSlug === organization?.shortName?.toLowerCase()"
  class="wrapper"
  [ngStyle]="computedStyle"
>
  <div class="left" *ngIf="!!isFromCurrentUser"></div>
  <h1>
    {{
      organization.name || 'Org Name Unavailable'
        | stringTransform: 'capitalizeEachWord'
    }}
    <!-- <span>Marketplace</span> -->
  </h1>

  <div class="buttons" *ngIf="!!isFromCurrentUser">
    <a href="javascript:void(0)" class="button" (click)="shareModalOpen = true">
      <app-shared-icon name="share-outline" [size]="14"></app-shared-icon>
      Share Your Marketplace
    </a>
  </div>
</div>

<app-shared-organization-share
  [open]="shareModalOpen"
  (handleClose)="shareModalOpen = false"
></app-shared-organization-share>
